import { useNewsboardPostProfileContext } from '../../../Newsboard.hooks'
import {
  getNewsboardPostProfileEditMessageInitialValues,
  getNewsboardPostProfileEditMessagePayload,
  getNewsboardPostProfileEditMessageValidationSchema,
  NewsboardPostProfileEditMessageModal,
} from '../../../NewsboardPostProfileEditMessageModal'

export function useNewsboardPostProfileEditMessage() {
  const { handleCloseModal, handleUpdateEntity, postData, setModal } =
    useNewsboardPostProfileContext()

  async function handleSubmit({ value }) {
    await handleUpdateEntity(value)
    handleCloseModal()
  }

  function handleOpenModal() {
    const ticker = postData?.isTvTicker

    setModal(
      <NewsboardPostProfileEditMessageModal
        getPayload={getNewsboardPostProfileEditMessagePayload}
        initialValues={getNewsboardPostProfileEditMessageInitialValues(
          postData?.text
        )}
        ticker={ticker}
        validationSchema={getNewsboardPostProfileEditMessageValidationSchema(
          ticker
        )}
        onClose={handleCloseModal}
        onSubmit={handleSubmit}
      />
    )
  }

  return { handleOpenModal }
}
